import React from 'react';
import { withStyles } from "@mui/styles";

const styles = {
  root: {
    fontWeight: 500,
    fontSize: '0.7225em',
    opacity:'0.8',
    textTransform:'uppercase'
  },
};

function KeywordSm({children, className='', classes, ...divProps}) {
  return <span className={classes.root}>{children}</span>;
};

export default withStyles(styles)(KeywordSm);
